/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ExternalTypeEnum,
    ExternalTypeEnumFromJSON,
    ExternalTypeEnumFromJSONTyped,
    ExternalTypeEnumToJSON,
} from './ExternalTypeEnum';
import {
    LookupKeyEnum,
    LookupKeyEnumFromJSON,
    LookupKeyEnumFromJSONTyped,
    LookupKeyEnumToJSON,
} from './LookupKeyEnum';
import {
    SourceSurveyEnum,
    SourceSurveyEnumFromJSON,
    SourceSurveyEnumFromJSONTyped,
    SourceSurveyEnumToJSON,
} from './SourceSurveyEnum';
import {
    SubscriptionEnum,
    SubscriptionEnumFromJSON,
    SubscriptionEnumFromJSONTyped,
    SubscriptionEnumToJSON,
} from './SubscriptionEnum';
import {
    SubscriptionSourceEnum,
    SubscriptionSourceEnumFromJSON,
    SubscriptionSourceEnumFromJSONTyped,
    SubscriptionSourceEnumToJSON,
} from './SubscriptionSourceEnum';
import {
    UserRoleEnum,
    UserRoleEnumFromJSON,
    UserRoleEnumFromJSONTyped,
    UserRoleEnumToJSON,
} from './UserRoleEnum';

/**
 * 
 * @export
 * @interface UserProfileDto
 */
export interface UserProfileDto {
    /**
     * 
     * @type {UserRoleEnum}
     * @memberof UserProfileDto
     */
    role: UserRoleEnum | null;
    /**
     * 
     * @type {SourceSurveyEnum}
     * @memberof UserProfileDto
     */
    sourceSurvey: SourceSurveyEnum | null;
    /**
     * 
     * @type {SubscriptionEnum}
     * @memberof UserProfileDto
     */
    subscription: SubscriptionEnum | null;
    /**
     * 
     * @type {SubscriptionEnum}
     * @memberof UserProfileDto
     */
    scheduledSubscription?: SubscriptionEnum | null;
    /**
     * 
     * @type {SubscriptionSourceEnum}
     * @memberof UserProfileDto
     */
    subscriptionSource: SubscriptionSourceEnum | null;
    /**
     * 
     * @type {LookupKeyEnum}
     * @memberof UserProfileDto
     */
    interestedInSubscription: LookupKeyEnum | null;
    /**
     * 
     * @type {SourceSurveyEnum}
     * @memberof UserProfileDto
     */
    suggestedSourceSurvey?: SourceSurveyEnum | null;
    /**
     * 
     * @type {LookupKeyEnum}
     * @memberof UserProfileDto
     */
    lookupKey?: LookupKeyEnum | null;
    /**
     * 
     * @type {ExternalTypeEnum}
     * @memberof UserProfileDto
     */
    externalType?: ExternalTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDto
     */
    zendeskToken?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDto
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserProfileDto
     */
    isOnWaitingList: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDto
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDto
     */
    nickname: string;
    /**
     * 
     * @type {Date}
     * @memberof UserProfileDto
     */
    subscriptionEndDate: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserProfileDto
     */
    newsletter: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserProfileDto
     */
    agreedTerms: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserProfileDto
     */
    hadTrialing: boolean;
}

export function UserProfileDtoFromJSON(json: any): UserProfileDto {
    return UserProfileDtoFromJSONTyped(json, false);
}

export function UserProfileDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserProfileDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'role': UserRoleEnumFromJSON(json['role']),
        'sourceSurvey': SourceSurveyEnumFromJSON(json['sourceSurvey']),
        'subscription': SubscriptionEnumFromJSON(json['subscription']),
        'scheduledSubscription': !exists(json, 'scheduledSubscription') ? undefined : SubscriptionEnumFromJSON(json['scheduledSubscription']),
        'subscriptionSource': SubscriptionSourceEnumFromJSON(json['subscriptionSource']),
        'interestedInSubscription': LookupKeyEnumFromJSON(json['interestedInSubscription']),
        'suggestedSourceSurvey': !exists(json, 'suggestedSourceSurvey') ? undefined : SourceSurveyEnumFromJSON(json['suggestedSourceSurvey']),
        'lookupKey': !exists(json, 'lookupKey') ? undefined : LookupKeyEnumFromJSON(json['lookupKey']),
        'externalType': !exists(json, 'externalType') ? undefined : ExternalTypeEnumFromJSON(json['externalType']),
        'zendeskToken': !exists(json, 'zendeskToken') ? undefined : json['zendeskToken'],
        'id': json['id'],
        'email': json['email'],
        'isOnWaitingList': json['isOnWaitingList'],
        'fullName': json['fullName'],
        'nickname': json['nickname'],
        'subscriptionEndDate': (json['subscriptionEndDate'] === null ? null : new Date(json['subscriptionEndDate'])),
        'newsletter': json['newsletter'],
        'agreedTerms': json['agreedTerms'],
        'hadTrialing': json['hadTrialing'],
    };
}

export function UserProfileDtoToJSON(value?: UserProfileDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'role': UserRoleEnumToJSON(value.role),
        'sourceSurvey': SourceSurveyEnumToJSON(value.sourceSurvey),
        'subscription': SubscriptionEnumToJSON(value.subscription),
        'scheduledSubscription': SubscriptionEnumToJSON(value.scheduledSubscription),
        'subscriptionSource': SubscriptionSourceEnumToJSON(value.subscriptionSource),
        'interestedInSubscription': LookupKeyEnumToJSON(value.interestedInSubscription),
        'suggestedSourceSurvey': SourceSurveyEnumToJSON(value.suggestedSourceSurvey),
        'lookupKey': LookupKeyEnumToJSON(value.lookupKey),
        'externalType': ExternalTypeEnumToJSON(value.externalType),
        'zendeskToken': value.zendeskToken,
        'id': value.id,
        'email': value.email,
        'isOnWaitingList': value.isOnWaitingList,
        'fullName': value.fullName,
        'nickname': value.nickname,
        'subscriptionEndDate': (value.subscriptionEndDate === null ? null : value.subscriptionEndDate.toISOString()),
        'newsletter': value.newsletter,
        'agreedTerms': value.agreedTerms,
        'hadTrialing': value.hadTrialing,
    };
}

